import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../../components/button/MasterButton";

import { CloseOrCancelIcon } from "../../../assets/CloseOrCancel";

import "./participantInfoModal.css";

import Skeleton from "../../../components/skeleton/Skeleton";

import Tabmenu, { TabMenuType } from "../../../components/tabmenu/Tabmenu";

export type ParticipantInfoModalProps = {
    index: number;
    onCloseClicked: () => void;
};

const ParticipantInfoModal: React.FC<ParticipantInfoModalProps> = ({ index, onCloseClicked }) => {

    return (
        <>  
            <div className="participantinfo-modal-detail">
                {/* Header Section with Background Image */}
                <div className="header">
                    <div className="left-content">
                        <div className="participant-status">Unanomalous</div>
                        <div className="participant-id-label">Participant</div>
                        <div className="participant-id">LAS004NNN</div>
                    </div>

                    <div className="organization-study">
                        <span>Organization A</span>
                        <br />
                        <span>Study A2</span>
                    </div>

                    <MasterButton
                        options={{
                            layoutType: ButtonLayoutType.Icon,
                            size: ButtonSize.Medium,
                            variation: ButtonVariation.Clean,
                            label: "",
                            icon: <CloseOrCancelIcon></CloseOrCancelIcon>,
                            className: "close-button",
                        }}
                        onClick={() => {
                            onCloseClicked();
                        }}
                    />
                </div>

                {/* Content Area */}
                <div className="menu">
                    <Tabmenu
                        items={[
                            {
                                type: TabMenuType.ACTIVE,
                                value: 0,
                                title: "Health Data",
                            },
                            {
                                type: TabMenuType.UNASSIGNED,
                                value: 0,
                                title: "Sensor",
                            },
                        ]}
                        isLoading={false}
                        onTabSelected={(index: number) => {
                            console.log("Tab Selected ", index);
                        }}
                        isDisabled={false}
                    />
                </div>

                <div className="content">
                    <div className="section-title">Anomalies</div>
                    <div className="no-anomalies">No Anomalies</div>
                </div>

                <div className="empty-space"></div>
            </div>
        </>
    );
};

export default ParticipantInfoModal;


